import { BlockFormatFlags, getBlockFormats } from './getBlockFormats';

interface DetectBlockFormatsParams {
  /** Optional so a missing question yields all-false rather than throwing. */
  question?: { questionText: string; explanation: string };
  answers?: Array<{ text: string }>;
}

/**
 * ORs {@link getBlockFormats} across a question's fields. Answer choices can't
 * produce block formats in the editor, but they're scanned too so the "in any
 * field" semantics hold. Mirrors `countMathEquations`.
 */
export function detectBlockFormats({
  question,
  answers,
}: DetectBlockFormatsParams): BlockFormatFlags {
  if (question == null) {
    return {
      hasCodeBlock: false,
      hasOrderedList: false,
      hasUnorderedList: false,
    };
  }

  const htmlStrings = [
    question.questionText,
    question.explanation,
    ...(answers ?? []).map((answer) => answer.text),
  ].filter(Boolean);

  return htmlStrings.reduce<BlockFormatFlags>(
    (acc, html) => {
      const flags = getBlockFormats(html);
      return {
        hasCodeBlock: acc.hasCodeBlock || flags.hasCodeBlock,
        hasOrderedList: acc.hasOrderedList || flags.hasOrderedList,
        hasUnorderedList: acc.hasUnorderedList || flags.hasUnorderedList,
      };
    },
    { hasCodeBlock: false, hasOrderedList: false, hasUnorderedList: false }
  );
}
